const {pick, omit, toPairs} = require('lodash')
const pickChangedFields = require('./pickChangedFields')

const inputOk = (input, comparator, type) => {
  if (type === 'min') {
    return input < comparator && input > 0 && countDecimals(parseFloat(input)) <= 1
  } else {
    return input > comparator && input < 5 && countDecimals(parseFloat(input)) <= 1
  }
}

const countDecimals = (value) => {
  if (Math.floor(value) !== value)
    return value.toString().split(".")[1].length || 0;
  return 0;
}


module.exports = (angularModule) => {
  angularModule.directive('mapRangeValidate', () => {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        mapRangeValidate: '&',
        validateType: '='
      },
      link: function (scope, elem, attr, ctrl) {
        ctrl.$parsers.unshift(function (value) {
          var valid = inputOk(value, scope.mapRangeValidate(), scope.validateType);
          ctrl.$setValidity('mapRangeValidate', valid);
          return value;
        });
        ctrl.$formatters.unshift(function (value) {
          ctrl.$setValidity('mapRangeValidate', inputOk(value, scope.mapRangeValidate(), scope.validateType));
          return value;
        });
      }
    };
  })
  angularModule.directive('brandConfigEditor', () => {
    return {
      restrict: 'E',
      template: require('./brandConfigEditor.html'),
      scope: {
        model: '='
      },
      controller: ($scope, $http, providerService, browserService, userManagerService) => {
        $scope.loadingProviders = true;
        $scope.isIE = browserService.isMSIE()

        function applyProviderDefaults() {
          if (!!($scope.allProviders && $scope.model)) {
            for (let p of $scope.allProviders) {
              $scope.model.providerMap[p.id] = $scope.model.providerMap[p.id] || 'default'
            }

          }
        }

        let refreshUsers = false
        function loadUsers(query) {
          if (!!($scope.model && $scope.model.acctSelection)) {
            if (!$scope.users) {
              $scope.usersInitializing = true
            }
            const accountSelected = $scope.model.acctSelection.selected

            if ($scope.users && !refreshUsers && !query) {
              return
            }

            userManagerService.listUsers(accountSelected.id, query || "",0, 100).then(response => {
              $scope.users = response.users.filter(user => user.enabled != false)
              if (query && query !== "") {
                refreshUsers = true
              }
              $scope.usersInitializing = false
            })
          }
        }

        async function loadAllUsers(guide){
          const accountSelected = $scope.model.acctSelection.selected
          if(! $scope.usersCache ) {
            userManagerService.listUsers(accountSelected.id,"",0, 10000).then(response => {
              $scope.usersCache = response.users.filter(user => user.enabled != false)
              $scope.users = $scope.usersCache
              guide.activeForUsers = $scope.users.map(user => user.id)
            })
          } else{
            $scope.users = $scope.usersCache
            guide.activeForUsers = $scope.users.map(user => user.id)
          }
        }

        $scope.selectAllUsers = async (guide) => {
          loadAllUsers(guide)
        }

        $scope.clearUserSelection = async (guide) => {
          guide.activeForUsers = []
        }

        $scope.searchUsersFilter = async (query, guide) => {
           await loadUsers(query)
          //Now add any users that are in the guide that didn't come back in the query
          userManagerService.getUsers(guide.activeForUsers).then(response => {
            $scope.users = $scope.users || []
            const ids = $scope.users.map(user => user.id)
            for (var key in response){
              if(! ids.includes(key)){
                let user = response[key]
                $scope.users.push(user)
              }
            }
          })

        }


        $scope.addGuide = function () {
          const newGuide = {
            name: "new guide",
            userguidingId: null,
            containerId: null,
            alreadyShownToUsers: [],
            activeForUsers: [],
            activeForUserType: "None",
            isActive: true,
            isNPS: false,
            onlyShowOncePerUser: true
          }
          $scope.model.userguides.push(newGuide)
        }

        $scope.deleteGuide = function (guide) {
          const index = $scope.model.userguides.findIndex(x => x == guide)
          $scope.model.userguides.splice(index, 1) //remove from shown
        }

        $scope.$watch(() => $scope.model && $scope.model.providerMap, applyProviderDefaults);


        $scope.$watch(() => $scope.model && $scope.model.acctSelection.selected, loadUserInfo)


        function loadUserInfo() {
          if (!!($scope.model && $scope.model.acctSelection)) {
            const accountSelected = $scope.model.acctSelection.selected
            userManagerService.userTypes(accountSelected.id).then((resp) => {
              $scope.userTypes = resp.data.userTypes.map(x => x.name);
              $scope.userTypes.unshift("None")
            })

          }

        }


        providerService.allProviders(true).then(providers => {
          $scope.loadingProviders = false;
          $scope.allProviders = providers;
          applyProviderDefaults()
        });

        $scope.type = 'tab'

        let _avgMin, _avgMax

        $scope.$watch('model', model => {
          if (model) {
            _avgMin = model.mapRange.averageMin
            _avgMax = model.mapRange.averageMax
          }
        }, 1)

        $scope.rangesliderCss = {
          excellent: {left: undefined, width: undefined},
          excellentCentered: {left: undefined},
          average: {left: undefined, width: undefined},
          averageCentered: {left: undefined},
          poor: {left: undefined, width: undefined},
        }

        $scope.form = {
          ieMapRange: {}
        }

        const updateRangeSliderStyle = () => {
          const maxWidth = 210
          const handleWidth = 30
          let exLeft, exWidth, avgLeft, avgWidth, poorLeft, poorWidth
          exLeft = maxWidth * _avgMax / 5
          exWidth = maxWidth - exLeft

          avgLeft = maxWidth * _avgMin / 5
          avgWidth = exLeft - avgLeft

          poorLeft = 0
          poorWidth = avgLeft - 0

          $scope.rangesliderCss.excellent.left = `${exLeft}px`
          $scope.rangesliderCss.excellent.width = `${exWidth}px`
          $scope.rangesliderCss.average.left = `${avgLeft}px`
          $scope.rangesliderCss.average.width = `${avgWidth}px`
          $scope.rangesliderCss.averageCentered.left = `${avgLeft - handleWidth * _avgMin / 5}px`
          $scope.rangesliderCss.excellentCentered.left = `${exLeft - handleWidth * _avgMax / 5}px`
          $scope.rangesliderCss.poor.left = `${poorLeft}px`
          $scope.rangesliderCss.poor.width = `${poorWidth}px`
        }

        $scope.mapValues = {
          averageMin: (...args) => {
            const input = args[0];
            if (args.length) {
              const rVal = inputOk(input, _avgMax, 'min') ? _avgMin = input : _avgMin
              updateRangeSliderStyle()
              if ($scope.model) {
                $scope.model.mapRange.averageMin = rVal
              }
              return rVal
            }
            return _avgMin
          },
          averageMax: (...args) => {
            const input = args[0];
            if (args.length) {
              const rVal = inputOk(input, _avgMin, 'max') ? _avgMax = input : _avgMax
              updateRangeSliderStyle()
              if ($scope.model) {
                $scope.model.mapRange.averageMax = rVal
              }
              return rVal
            }
            return _avgMax
          }
        }
        $scope.transformKey = (key) => {
          return key.replace(/^hide/, '')
            .split(/(?=[A-Z])/)
            .map(x => x.slice(0, 1).toUpperCase() + x.slice(1))
            .join(" ")
            .replace('Review Generation', 'Review Builder')
            .replace('Sentiment', 'Pulse')
            .replace('Insights', 'Analytics')
            .replace('Review Builder Contact Info', 'Show Review Builder Contact Info in Email Alerts')
            .replace('New Ui Opt In', 'Show New UI Opt In')
        };

        $scope.setType = (type) => {
          if ($scope.type !== type) {
            $scope.type = type;
          }
        };

        $scope.toggleVisibility = (key, restObj) => {
          restObj[key] = !restObj[key];
        };

        $scope.switchValue = (key, value) => {
          if (key.indexOf('hide') === 0) {
            return !value
          } else {
            return value
          }
        }
      }
    }
  })
}


module.exports.fromConfig = (config) => {
  // restrictions
  const restrictions = config.brandConfig.restrictions;
  const userguides = config.brandConfig.userguiding || [];
  const tabArray = [
    'hideSnapshot', 'hideReviews', 'hideListings', 'hideRankings',
    'hideMedia', 'hideWorkflow', 'hideReviewGeneration', 'hideSentiment', 'hideChatter2',
    'hideInsights'
  ];
  const tabRestrictions = pick(restrictions, tabArray);
  const featureRestrictions = omit(restrictions, tabArray);

  // providers
  const whiteListedProviders = config.accountConfig.whiteListedProviders;
  const blackListedProviders = config.accountConfig.blackListedProviders;
  const providerMap =
    blackListedProviders.reduce(
      (sum, p) => ({...sum, [p]: "blacklisted"}),
      whiteListedProviders.reduce(
        (sum, p) => ({...sum, [p]: "whitelisted"}),
        {}
      )
    )
  const mapRange = config.brandConfig.mapRange

  return {
    tabRestrictions,
    featureRestrictions,
    providerMap,
    mapRange,
    userguides
  }
};

module.exports.toConfig = (model) => {
  return {
    brandConfig: {
      restrictions: {
        ...model.tabRestrictions,
        ...model.featureRestrictions
      },
      mapRange: {averageMax: parseFloat(model.mapRange.averageMax), averageMin: parseFloat(model.mapRange.averageMin)},
      userguiding: model.userguides,
    },
    accountConfig: {
      whiteListedProviders: toPairs(model.providerMap).filter(([k, v]) => v === "whitelisted").map(kv => kv[0]),
      blackListedProviders: toPairs(model.providerMap).filter(([k, v]) => v === "blacklisted").map(kv => kv[0]),
    }
  }
};

module.exports.sparsify = (before, after) => {
  return {
    tabRestrictions: pickChangedFields(before.tabRestrictions, after.tabRestrictions),
    featureRestrictions: pickChangedFields(before.featureRestrictions, after.featureRestrictions),
    providerMap: after.providerMap,
    mapRange: after.mapRange,
    userguides: after.userguides
  }
}
